import React, { useEffect, useState } from "react";
import { handleOutsideClick } from "../../../../Helpers/HandleOutsideClick";

const ViewResumeModal = ({ show, onClose, resumeUrl }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [shouldRender, setShouldRender] = useState(show);

	useEffect(() => {
		if (show) {
			setShouldRender(true);

			setTimeout(() => {
				setIsVisible(true);
			}, 10);
		} else {
			setIsVisible(false);

			setTimeout(() => {
				setShouldRender(false);
			}, 500);
		}
	}, [show]);

	if (!shouldRender) return null;

	return (
		<div
			className={`fixed inset-0 z-50 flex justify-end transition-opacity duration-500 ${isVisible ? "bg-black/40 opacity-100" : "bg-black/0 opacity-0"}`}
			onClick={(e) => handleOutsideClick(e, onClose)}
		>
			{/* Drawer */}
			<div
				onClick={(e) => e.stopPropagation()}
				className={`bg-white h-full w-[65%] shadow-[ -10px_0px_30px_rgba(0,0,0,0.15) ] flex flex-col transform transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "translate-x-0" : "translate-x-full"}`}
			>
				{/* Header */}
				<div className="flex justify-between items-center px-6 py-4 border-b">
					<h3 className="font-semibold text-lg">Candidate Resume</h3>

					<button
						onClick={onClose}
						className="text-gray-500 hover:text-black text-xl"
					>
						✕
					</button>
				</div>

				{/* Body */}
				<div className="flex-1 overflow-hidden">
					{resumeUrl ? (
						<iframe src={resumeUrl} title="Resume" className="w-full h-full" />
					) : (
						<div className="flex items-center justify-center h-full text-gray-500">
							Resume not available.
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ViewResumeModal;
